import { Component } from 'shimmer'

import { Loader } from '@/utils/Loader'

import {
  PlaneBufferGeometry,
  MeshNormalMaterial,
  DirectionalLight,
  AmbientLight,
  Vector3
} from 'three'

import { emitter } from '@/utils/emitter'

import { BlurredReflector } from '@/webGL/objects/BlurredReflector'
import { webGL } from '@/webGL/WebGL'

export class BaseEnvironment extends Component {
  constructor (url) {
    super('Environment')
    this.promise = new Promise(resolve => {this.resolve = resolve})

    this.destroy = this.destroy.bind(this)

    this.loaderGround = Loader.load(url, false, obj => {
      obj.receiveShadow = true
      obj.castShadow = false
    }).then(obj => {
      this.obj = obj.scene
      this.add(this.obj)
    })

    this.addLights()

    this.loaderGround.then(this.resolve)
  }

  onDestroy () {
    this.destroy()

    this.obj.traverse(child => {
      if (child.isMesh) {
        child.material.dispose()
        child.geometry.dispose()
      }
    })

    webGL.scene.remove(this.directional)
    webGL.scenePerso.remove(this.directionalClone)
    webGL.scene.remove(this.ambient)
    webGL.scenePerso.remove(this.ambientClone)
  }

  addLights () {
    this.directional = new DirectionalLight(0xffffff, 1)
    this.directional.position.set(-1200, 900, 1000)
    this.directional.lookAt( new Vector3(0, 0, 0) )
    webGL.scene.add(this.directional)
    this.directionalClone = this.directional.clone()
    this.directionalClone.castShadow = true
    this.directionalClone.shadow.camera.bottom = -1000
    this.directionalClone.shadow.camera.top = 1000
    this.directionalClone.shadow.camera.left = -1000
    this.directionalClone.shadow.camera.right = 1000
    this.directionalClone.shadow.camera.far = 20000
    this.directionalClone.shadow.camera.near = 100
    this.directionalClone.shadow.mapSize.width = 2048
    this.directionalClone.shadow.mapSize.height = 2048
    this.directionalClone.shadow.bias = -0.0004
    this.directionalClone.shadow.camera.updateProjectionMatrix()
    webGL.scenePerso.add(this.directionalClone)

    this.ambient = new AmbientLight(0xffffff, .3)
    this.ambientClone = this.ambient.clone()
    webGL.scene.add(this.ambient)
    webGL.scenePerso.add(this.ambientClone)
  }
}